import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

// Toggle Switch Component
const ToggleSwitch = ({ checked, onChange, disabled, }) => {
    return (
        <label
            style={{
                position: "relative",
                display: "inline-block",
                width: "36px",
                height: "20px",
                cursor: disabled ? "not-allowed" : "pointer",
                opacity: disabled ? 0.5 : 1,
            }}
        >
            <input
                type="checkbox"
                checked={checked}
                onChange={onChange}
                disabled={disabled}
                style={{ display: "none" }}
            />
            <span
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: checked ? "#23B4C3" : "#D1D5DB",
                    borderRadius: "20px",
                    transition: "0.3s",
                }}
            ></span>
            <span
                style={{
                    position: "absolute",
                    left: checked ? "18px" : "2px",
                    top: "2px",
                    width: "16px",
                    height: "16px",
                    backgroundColor: "#fff",
                    borderRadius: "50%",
                    transition: "0.3s",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
                }}
            ></span>
        </label>
    );
};
const PERMISSION_AREAS = [
    { key: "companyOverview", label: "Company Overview", showView: true, showEdit: true },
    { key: "contentManagement", label: "Content Management", showView: true, showEdit: true },
    { key: "lipSync", label: "Lip Sync Access", showView: false, showEdit: true },
];



const EditRoleAccessModal = ({ show, onHide, onSave, userPermissions }) => {
    const initialPermissions = {
        companyOverview: { view: false, edit: false },
        customizeRoleplay: { view: false, edit: false },
        contentManagement: { view: false, edit: false },
        lipSync: { edit: false },
    };

    const [permissions, setPermissions] = useState(initialPermissions);
    console.log("Permissions: ", userPermissions)
    useEffect(() => {
        if (show && userPermissions) {
            const mappedPermissions = {};


            PERMISSION_AREAS.forEach(area => {
                mappedPermissions[area.key] = { view: false, edit: false };
            });
            userPermissions.forEach(p => {
                mappedPermissions[p.area] = {
                    view: p.level.includes("view_only"),
                    edit: p.level.includes("edit"),
                };
            });
            setPermissions(mappedPermissions);
        }
    }, [show, userPermissions]);



    const togglePermission = (area, type) => {
        setPermissions((prev) => ({
            ...prev,
            [area]: { ...prev[area], [type]: !prev[area][type] },
        }));
    };

    const handleSave = () => {
        onSave(permissions);
        onHide();
    };

    return (
        <Modal show={show}
            onHide={onHide}
            backdrop="static"
            keyboard={false}
            dialogClassName="modal-38"
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            <Modal.Body style={{ padding: "24px" }}>
                {/* Title */}
                <div style={{ marginBottom: "20px" }}>
                    <h3
                        style={{
                            fontFamily: "ClashDisplay-Semibold",
                            fontWeight: "700",
                            fontSize: "24px",
                            color: "#1f2937",
                            lineHeight: "32px",
                            marginBottom: "16px",
                            verticalAlign: "middle",
                            letterSpacing: "0%"
                        }}
                    >
                        Edit Access
                    </h3>
                </div>

                {/* Table Header */}
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                        <tr style={{}}>
                            <th
                                style={{
                                    color: "#111827",
                                    textAlign: "left",
                                    fontWeight: "600",
                                    fontSize: "16px",
                                    textAlign: 'left',
                                    padding: '16px 24px',
                                    lineHeight: "24px",
                                    backgroundColor: '#F3F4F6',
                                    fontFamily: "Plus Jakarta Sans",
                                    borderTopLeftRadius: "12px",
                                    paddingBottom: '8px'
                                }}
                            >
                                Permission Area
                            </th>
                            <th
                                style={{
                                    color: "#111827",
                                    textAlign: "left",
                                    fontWeight: "600",
                                    fontSize: "16px",
                                    textAlign: 'left',
                                    padding: '16px 24px',
                                    lineHeight: "24px",
                                    backgroundColor: '#F3F4F6',
                                    fontFamily: "Plus Jakarta Sans",

                                    paddingBottom: '8px'
                                }}
                            >
                                View Only
                            </th>
                            <th
                                style={{
                                    color: "#111827",
                                    textAlign: "left",
                                    fontWeight: "600",
                                    fontSize: "16px",
                                    textAlign: 'left',
                                    padding: '16px 24px',
                                    lineHeight: "24px",
                                    backgroundColor: '#F3F4F6',
                                    fontFamily: "Plus Jakarta Sans",
                                    borderTopRightRadius: "12px",
                                    paddingBottom: '8px'
                                }}
                            >
                                Edit and Create
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {Object.keys(permissions).map(key => {
                            const perms = permissions[key];
                            const areaConfig = PERMISSION_AREAS.find(a => a.key === key);
                            const label = areaConfig ? areaConfig.label : key; // use key as label if not predefined
                            const showView = areaConfig ? areaConfig.showView : true; // default true for extra areas
                            const showEdit = areaConfig ? areaConfig.showEdit : true;

                            return (
                                <tr key={key}>
                                    <td style={{ padding: "16px 24px", verticalAlign: "middle", fontWeight: "500" }}>
                                        {label}
                                    </td>

                                    <td style={{ padding: "16px 24px", textAlign: "center" }}>
                                        {showView ? (
                                            <ToggleSwitch
                                                checked={perms.view}
                                                onChange={() => togglePermission(key, "view")}
                                            />
                                        ) : "-"}
                                    </td>

                                    <td style={{ padding: "16px 24px", textAlign: "center" }}>
                                        {showEdit ? (
                                            <ToggleSwitch
                                                checked={perms.edit}
                                                onChange={() => togglePermission(key, "edit")}
                                            />
                                        ) : "-"}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>

                </table>
                {/* Buttons */}
                <div
                    style={{
                        display: "flex",
                        gap: "16px", // adds spacing between buttons
                        marginTop: "24px",
                        width: "100%",
                    }}
                >
                    <Button
                        variant=""
                        className="back-btn"
                        style={{
                            flex: 1,
                            color: "#9CA3AF",
                            borderRadius: "9999px",
                            padding: "12px 0",
                            fontWeight: "500",
                            fontSize: "16px",
                            border: "1px solid #9CA3AF"
                        }}
                        onClick={onHide}
                    >
                        Back
                    </Button>

                    <Button
                        style={{
                            flex: 1,
                            backgroundColor: "#23B4C3",
                            border: "none",
                            borderRadius: "9999px",
                            padding: "12px 0",
                            fontWeight: "700",
                            fontSize: "16px",
                        }}
                        onClick={handleSave}
                    >
                        Save
                    </Button>
                </div>

            </Modal.Body>
        </Modal>
    );
};

export default EditRoleAccessModal;
